// extracted by mini-css-extract-plugin
module.exports = {"home":"styles_home__2Q5hq"};